/*@flow*/
import mkDropdownTemplate from './mkDropdownTemplate';
import * as loaders from 'queries/loaders';

export default (mkDropdownTemplate({
  isMulti: false,
  isCreatable: true,
  loadValues: () => {
    return loaders.developmentStatusesLoader();
  },
}): any);
